package ir.yusefpasha.util

import org.jetbrains.compose.web.css.ms

object Constants {
    //const val FONT_FAMILY = "Roboto"
    const val FONT_FAMILY = "Georgia"
    const val SECTION_WIDTH = 1920
    val ANIMATION_DURATION = 200.ms

    const val FORM_ACTION_URL = "https://formspree.io/f/mdovrglj"
}

object Res {
    object Image {
        const val LOGO = "logo.png"
        const val ABOUT = "about.jpg"
        const val PROFILE = "profile.png"
        const val BACKGROUND = "background.png"

        const val PORTFOLIO_1 = "project_crypto.jpg"
        const val PORTFOLIO_2 = "project_legzo.png"
        const val PORTFOLIO_3 = "project_dailyCheck.png"
        const val PORTFOLIO_4 = "project_music.jpg"
        const val PORTFOLIO_5 = "project_kla.png"
        const val PORTFOLIO_6 = "project_weather.jpg"

        const val AVATAR_1 = "person1.jpg"
        const val AVATAR_2 = "person2.jpg"
        const val AVATAR_3 = "person3.jpg"
        const val AVATAR_4 = "person4.jpg"
        const val AVATAR_5 = "person5.jpg"
        const val AVATAR_6 = "person6.jpg"
    }

    object Icon {
        const val KMP = "kotlin.svg"
        const val WEB = "web.svg"
        const val ANDROID = "android.svg"
        const val BACKEND = "server.svg"
        const val WINDOWS = "windows.svg"

        const val TEAM = "team.svg"
        const val ACTIVE = "active.svg"
        const val COMPLETED = "complete.svg"
        const val SATISFIED = "satisfied.svg"

        const val STAR = "star.svg"
    }

    object Links {
        const val GITHUB = "https://github.com/yusefpasha"
        const val TWITTER = "https://twitter.com/yusef_pasha"
        const val TELEGRAM = "https://t.me/yusef_pasha"
        const val INSTAGRAM = "https://instagram.com/yusef_pasha"
    }
}